import React from 'react'
import TopBar from '../bars/top-bar'
import BackIconButton from '../buttons/BackIconButton'
import HeadingBeta from '../headings/heading-beta'
import InfoBlock from '../texts/info-block'

const createTopBarLeftChildren = props => {
  const topBarLeftChildren = [<BackIconButton key='BackIconButton' />]
  return topBarLeftChildren
}

const Help = props => {
  return (
    <div className='detail-item inner-wrapper-wide'>
      <TopBar
        theme='light-bar'
        leftChildren={createTopBarLeftChildren(props)}
      />
      <HeadingBeta className='bottom-space'>Help</HeadingBeta>
      <InfoBlock>
        <p className='section-subtitle'>Creating an event</p>
        <p>
          Charities can register their event through the “administrator”
          platform of the site. Once registered and Charity information is
          entered an event page will be created where the charity can download
          information about the event, link the charities’ home page, and upload
          auction items they wish to auction. They can create time to open and
          close auction as well as set minimum bids and choose to make it Public
          (open to anyone) or private (open to only recipients they choose to
          share with). Charities can decide on the bidding increments for each
          item they auction. Chair-bids suggests 10% of the minimum bid.
        </p>
      </InfoBlock>
      <InfoBlock>
        <p className='section-subtitle'>Bidding</p>
        <p>
          Items will be sold to highest bidder, at the time the bidding closes.
          Bidding increments will be based on Charities choice. Chair-bids
          suggests 10% of the minimum bid. ($100.00 min bid =$10.00 increments)
          Bidder has option of creating a maximum bid of their choice, that will
          automatically bid for them until their maximum bid is reached.
        </p>
      </InfoBlock>
      <InfoBlock>
        <a href='mailto:help@chairbids.com'>help@chairbids.com</a>
      </InfoBlock>
    </div>
  )
}

export default Help



// WEBPACK FOOTER //
// ./src/ui/views/help.js